export default __webpack_public_path__ + "static/media/watchdog-1.5b669253.png";